import axios from 'axios'
import app from '@/main';
import store from '@/store'
import {getToken} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import {tansParams} from "@/utils/ruoyi";
import cache from '@/plugins/cache'
import {Toast} from 'vant'

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = {show: false};

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 60 * 60 * 1000
})
// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
     config.headers['Access-Control-Allow-Origin'] = '*'
    console.log('config', config)
    // 1:自建，2:三方
    let environmentType = 2
    if (environmentType === 2) {
        // 判断拼接？或 &
        if (config.url.includes('?')) {
            config.url = config.url + '&corpid=' + (localStorage.getItem('corpid') ? localStorage.getItem('corpid') : '')
        } else {
            config.url = config.url + '?corpid=' + (localStorage.getItem('corpid') ? localStorage.getItem('corpid') : '')
        }
        if (config.url.includes('processInstanceId=')) {
            config.url = config.url.replace(/(processInstanceId=\d+)\?/, '$1&');
            console.log('processInstanceId', config.url);
        }
    }


    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '&' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
        }
        const sessionObj = cache.session.getJSON('sessionObj')
        if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
            cache.session.setJSON('sessionObj', requestObj)
        } else {
            const s_url = sessionObj.url;                  // 请求地址
            const s_data = sessionObj.data;                // 请求数据
            const s_time = sessionObj.time;                // 请求时间
            const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
            cache.session.setJSON('sessionObj', requestObj)
        }
    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.msg || res.data.msg || errorCode['default']
        if (code === 401) {
            // store.dispatch('LogOut').then(() => {
            //     location.href = '/login';
            // })
            // 无效的会话，或者会话已过期，请重新登录
            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        } else if (code === 500) {
            // 服务器异常
            Toast.fail(msg)
            app.$loading.hide()
            return Promise.reject(msg)
        } else if (code === 601) {
            return Promise.reject('error')
        } else if (code !== 200) {
            return Promise.reject('error')
        } else if (code === 404) {
            return Promise.reject(new Error(msg))
        } else {
            return res.data
        }
    },
    error => {
        console.error('error -----------', error)
        return Promise.reject(error)
    }
)


export default service
